function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.06 8l9.653 12.906L8 31.399h2.186l8.504-9.187 6.87 9.187H33L22.805 17.767 31.845 8H29.66l-7.831 8.46L15.5 8H8.06zm3.216 1.61h3.417l15.092 20.178h-3.418L11.276 9.61z",
  fill: "#fff"
});

function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSocialTwitter;